<template>
  <GestionActualizacionMasiva/>
</template>
<script setup>
import GestionActualizacionMasiva from "@/views/actualizacionmasiva/components/GestionActualizacionMasiva.vue";
</script>
